<template>
    <v-container fluid>
        <v-row justify="center">
            <v-col cols="12" md="8">
                <v-card flat>
                <v-card-text>
                    <v-form>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                        outlined
                                        label="Name"
                                        v-model="$v.editedItem.name.$model"
                                        :error-messages="nameErrors"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <autocomplete
                                        :items="documentGroups"
                                        label="Select Document Category"
                                        title="name"
                                        :sub-title="[]"
                                        :selected-items="documentGroupsSelected"
                                        @autocomplete-selected="updateSelectedDocuments"
                                ></autocomplete>
                            </v-col>
                        </v-row>
                        <v-row v-if="isClientType">
                            <v-col cols="12">
                                <autocomplete
                                        :items="reportGroups"
                                        label="Select Report Category"
                                        title="name"
                                        :sub-title="[]"
                                        :selected-items="reportGroupsSelected"
                                        @autocomplete-selected="updateSelectedReports"
                                ></autocomplete>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col cols="6" sm="2">
                                <v-btn color="default" text @click="close">Cancel</v-btn>
                            </v-col>
                            <v-col cols="6" sm="2">
                                <v-btn color="primary"
                                       :loading="isSaving"
                                       :disabled="isSaving"
                                       @click="save">Save</v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <dialog-alert :text="alertText"
                      :alert-type="alertType"
                      :open="openAlert"
                      @alert-closed="alertClosed($event)">
        </dialog-alert>
        <dialog-alert :text="notFoundError"
                      :alert-type="alertTypes.ERROR"
                      :open="openNotFound"
                      @alert-closed="close()">
        </dialog-alert>
    </v-container>
</template>

<script>
    import alertEventBus from '@/eventBus/AlertEventBus';
    import {required, minLength} from 'vuelidate/lib/validators';
    import {EmployeeType,ClientType} from '../../../shared/dtos/Dtos';
    const Autocomplete = ()=> import( "@/components/common/Autocomplete");
    import { FORM_STATUS } from '@/shared/enums/FormStatuses';
    const DialogAlert = ()=> import( '@/components/common/DialogAlert');
    import {formUnsavedMixin} from "@/shared/mixins/FormUnsaved";
    import { ALPHA_NUMERIC_WITH_SPACES_VALIDATOR } from "@/shared/validators/Validators";
    import {GROUP_TYPE_ACTIONS} from '@/shared/enums/GroupTypes'
    import {WRONG_ID_SUPPLIED}  from "@/shared/enums/AlertTexts";
    import {ALERT_TYPES} from "@/shared/enums/AlertTexts";
    import {DOCUMENT_GROUP_TYPES} from "@/shared/enums/DocumentGroup";
    import {USER_TYPE} from "@/shared/enums/UserType";

    export default {
        name: "groupTypeForm",
        components: {Autocomplete, DialogAlert},
        mixins:[formUnsavedMixin],
        props: ['type', 'id', 'action'],
        data(){
            return {
                editedItem: {},
                documentGroups: [],
                reportGroups: [],
                documentGroupsSelected: [],
                reportGroupsSelected: [],
                types:{client: ClientType, employee: EmployeeType},
                isSaving: false,
                notFoundError: WRONG_ID_SUPPLIED,
                openNotFound: false,
                alertTypes: ALERT_TYPES
            };
        },
        validations: {
            editedItem:{
                name: {
                    required: required,
                    minLength: 2,
                    ALPHA_NUMERIC_WITH_SPACES_VALIDATOR
                }
            },
        },
        computed:{
            nameErrors(){
                const errors = [];
                if (!this.$v.editedItem.name.$dirty) {
                    return errors;
                }

                !this.$v.editedItem.name.required && errors.push('Name is required.')
                !this.$v.editedItem.name.ALPHA_NUMERIC_WITH_SPACES_VALIDATOR && errors.push('Name must contain only letters and numbers.')
                return errors;
            },
            templateTypeCapitalized(){
                return this.$options.filters.upperCaseFirstLetter(this.typeOfGroup);
            },
            typeOfGroup(){
                return this.type;
            },
            isClientType(){
                return this.type.toUpperCase() === USER_TYPE.CLIENT;
            }
        },
        methods:{
            async initialize(){
                this.editedItem = {... this.types[this.typeOfGroup]};

                await this.loadDocumentGroups();

                if(this.isClientType)
                    await this.loadReportGroups();

                if(this.id !== undefined)
                {
                    await this.$store.dispatch('getGroupType',{id: this.id});
                    this.editedItem = this.$store.getters.getGroupType;

                    if(!this.editedItem.hasOwnProperty('id'))
                    {
                        this.openNotFound = true;
                        return;
                    }
                    else
                    {
                        /**
                         * If clone then remove name and id from object
                         */
                        if(this.action === GROUP_TYPE_ACTIONS.CLONE.text)
                        {
                            delete this.editedItem.id;
                            this.editedItem.name = '';
                        }
                    }
                }

                if(this.editedItem.hasOwnProperty("documentGroups"))
                {
                    this.editedItem.documentGroups = Object.values(this.editedItem.documentGroups);
                    this.documentGroupsSelected = this.editedItem.documentGroups;
                }

                if(this.editedItem.hasOwnProperty("reportGroups"))
                {
                    this.editedItem.reportGroups = Object.values(this.editedItem.reportGroups);
                    this.reportGroupsSelected = this.editedItem.reportGroups;
                }
            },
            updateSelectedDocuments($event) {
                if (Array.isArray($event) && $event.length) {
                    this.$v.editedItem.$touch();
                }
                this.editedItem.documentGroups = $event;
                this.documentGroupsSelected = $event;
            },
            updateSelectedReports($event) {
                if (Array.isArray($event) && $event.length) {
                    this.$v.editedItem.$touch();
                }
                this.editedItem.reportGroups = $event;
                this.reportGroupsSelected = $event;
            },
            close(){
                this.resetValues();
                this.status = FORM_STATUS.CLOSE;
                this.$router.push({name: this.type+'TypeTable'});
            },
            resetValues(){
                this.$v.$reset();
                this.editedItem = {... this.types[this.type]};
                this.$store.commit('setGroupType',null);
            },
            async loadDocumentGroups(){
                //going backend
                try{
                    await this.$store.dispatch('getDocumentGroups',{type: DOCUMENT_GROUP_TYPES.DOCUMENT ,applyTo:this.typeOfGroup.toUpperCase()});
                    this.documentGroups = this.$store.getters.getDocumentGroups({type: DOCUMENT_GROUP_TYPES.DOCUMENT ,applyTo:this.typeOfGroup.toUpperCase()});
                }
                catch (e) {
                    //set alert
                    alertEventBus.setAlert({type:'error', msg: e.message});
                    return;
                }
            },
            async loadReportGroups(){
                //going backend
                try{
                    await this.$store.dispatch('getDocumentGroups',{type: DOCUMENT_GROUP_TYPES.REPORT});
                    this.reportGroups = this.$store.getters.getDocumentGroups({type: DOCUMENT_GROUP_TYPES.REPORT});
                }
                catch (e) {
                    //set alert
                    alertEventBus.setAlert({type:'error', msg: e.message});
                    return;
                }
            },
            async save(){
                this.$v.editedItem.$touch();
                if(this.$v.editedItem.$anyError){
                    return;
                }

                this.isSaving = true;

                try{
                    /**
                     * Parsing templates
                     */
                    this.editedItem.documentGroups = this.editedItem.documentGroups
                        ? this.editedItem.documentGroups.map((item) => {return {id:item.id,name:item.name}})
                        : [];

                    if(this.isClientType)
                        this.editedItem.reportGroups = this.editedItem.reportGroups
                            ? this.editedItem.reportGroups.map((item) => {return {id:item.id,name:item.name}})
                            : [];

                    await this.$store.dispatch('setGroupType',this.editedItem);
                    let response = this.$store.getters.getGroupType;

                    /**
                     * Updating list of document groups
                     */
                    this.$store.commit('set'+this.templateTypeCapitalized+'Types', []);
                }
                catch (e) {
                    alertEventBus.setAlert({type:'error', msg: e.message});
                    this.isSaving = false;
                    return;
                }

                this.close();
            }
        },
        async created(){
            this.initialize();
        }
    }
</script>

<style>
    .v-chip.white-span span {
        color: white !important;
    }
</style>